import React from 'react';
import './LoaderBar.css';

/**
 * LoaderBar Component
 * @param {Object} props
 * @param {number} props.percent - Completion percentage (0-100)
 */
function LoaderBar({ percent = 0 }) {
  return (
    <div className="page-blocker">
      <div className="loader-bar-container">
        <div
          className="loader-bar-fill"
          style={{ width: `${percent}%` }}
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
          role="progressbar"
          aria-label={`Progress: ${percent}%`}
        />
        <span className="loader-bar-label" id="loader-bar-label">
          {percent}%
        </span>
      </div>
    </div>
  );
}

export default LoaderBar;
